import { render } from "./suggestionFiltersModal.vue?vue&type=template&id=43eb3cb2&ts=true"
import script from "./suggestionFiltersModal.vue?vue&type=script&lang=ts"
export * from "./suggestionFiltersModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__